import { defineStore } from 'pinia'

export const useEmptyStateStore = defineStore('emptyState', {
  state: () => ({
    active: false,
    icon: '',
    title: '',
    description: ''
  }),

  actions: {
    updateEmptyState(data) {
      this.active = data.active
      this.icon = data.icon || ''
      this.title = data.title || ''
      this.description = data.description || ''
    }
  }
}) 